import Dialog from "../../atoms/dialog";
import { ChangeDelegateType } from '../delegates/ChangeDelegateType'

export function DelegateTypeChangeAlert(props) {
    const { invokeEditDelegateApi, onClose } = props;

    return (

        <Dialog
            title={"Routing rules will be invalid"}
            open={true}
            handleClose={onClose}
            paperProps={{ id: "delegateEditAlert" }}
        >

            <ChangeDelegateType invokeEditDelegateApi={invokeEditDelegateApi} onClose={onClose} />

        </Dialog >
    )
}